import React, { useEffect, useRef, useState } from "react";
import { useAPIs } from "../../apis/APIsConfig";
import { useForm } from "../../utils/hooks";
import { useGlobalStore } from "../../utils/global";
import { useNavigate } from "react-router-dom";
import {
  getPreguntasSeguridad,
  getResumenRespuestas,
  validarAfiliado,
  validarRespuestas,
} from "../../services/user";

import InputMask from "react-input-mask";
import GlobalLoading from "../../components/common/GlobalLoading";
import { formatDate } from "../../utils/moment";
import { convertToMoney } from "../../utils/number";
import {
  getPublicReporteEstadoCuenta,
} from "../../services/dashboard";
import Reaptcha from "reaptcha";

const PublicAccountStatements = () => {
  useAPIs();
  const navigate = useNavigate();
  var captchaRef;

  const [formState, setError, changeHandler, reset] = useForm({
    cedula: "",
    captcha: false,
  });
  const [preguntas, setPreguntas] = useState<any[]>([]);
  const [list, setList] = useState<any[]>([]);

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);
  
  useEffect(() => {
    var launcher = document.getElementById("launcher");
    launcher?.remove();

    var botprofrm = document.getElementById("botprofrm");
    botprofrm?.remove();
  }, []);
  
  function disableButton() {
    return !formState.data.cedula || !formState.data.captcha;
  }

  function submitForm() {
    if (!preguntas.length) {
      validarAfiliado(formState.data.cedula).then((resValAfi) => {
        if (resValAfi.data.value.esAfiliado) {
          getPreguntasSeguridad(formState.data.cedula).then((resPreguntas) => {
            console.info(resPreguntas);
            setPreguntas(resPreguntas.data.value);
          });
        } else {
          // TODO: mostrar botón afiliación?
        }
      });

      changeHandler("captcha", false)();
      captchaRef?.reset();
    } else {
      validarRespuestas(
        formState.data.cedula,
        preguntas.map((preg) => {
          return {
            codPregunta: preg.codPreguntas,
            valorRespuesta: preg.valorRespuesta,
          };
        })
      ).then((resVal) => {
        if (resVal && resVal.data.successed) {
          getResumenRespuestas(
            formState.data.cedula,
            preguntas.map((preg) => {
              return {
                codPregunta: preg.codPreguntas,
                valorRespuesta: preg.valorRespuesta,
              };
            })
          ).then((res) => {
            if (res) {
              setList(res.data.value);
            }
          });
        }
      });
    }
  }

  function onVerify(recaptchaResponse) {
    changeHandler("captcha", true)();
  }

  function handleChange(codPreguntas: number) {
    return (changeEvent) => {
      const pregs = [...preguntas];
      pregs.find((f) => f.codPreguntas === codPreguntas)["valorRespuesta"] =
        changeEvent.target.value;
      setPreguntas(pregs);
    };
  }

  function download(fechaCorte) { 
    getPublicReporteEstadoCuenta(
      fechaCorte,
      formState.data.cedula,
      preguntas.map((preg) => {
        return {
          codPregunta: preg.codPreguntas,
          valorRespuesta: preg.valorRespuesta,
        };
      }),3
    );
  }

  return (
    <>
      <GlobalLoading />
      <div className="block pt-6 md:pt-14 pb-10">
        <h1 className="text-primary-100 font-bold mb-2">
          Consulta tu Estado de Cuenta
        </h1>
        {list.length === 0 && (
          <p className="text-gray-70 text-body-1 font-body font-normal">
            Antes de continuar favor de{" "}
            <span className="font-semibold">ingresar su número de cédula</span>
          </p>
        )}
      </div>
      {list.length === 0 && (
        <form
          className="block space-y-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="form-group">
            <label>Digita tú número de cédula</label>
            <InputMask
              type="text"
              className="form-control large"
              placeholder="Ingresa tu documento"
              value={formState.data.cedula}
              onChange={changeHandler("cedula", undefined, "-")}
              mask="999-9999999-9"
              maskPlaceholder={"_"}
            />
          </div>

          {preguntas.map((pregunta, index) => (
            <div className="form-group" key={index}>
              <label className="checkbox-radio">
                <p className="font-body font-normal">{pregunta.descripcion}</p>
              </label>

              {pregunta.respuestas.map((respuesta, indexResp) => (
                <div className="form-group mb-2" key={indexResp}>
                  <label className="checkbox-radio">
                    <input
                      type="radio"
                      value={respuesta.valor}
                      name={"pregunta" + pregunta.codPreguntas}
                      onChange={handleChange(pregunta.codPreguntas)}
                    />
                    <p>{respuesta.valor}</p>
                  </label>
                </div>
              ))}
            </div>
          ))}

          <Reaptcha
              ref={(e) => (captchaRef = e)}
              sitekey={process.env.REACT_APP_SITE_KEY}
              onVerify={onVerify}
            />

          <button
            type="button"
            onClick={submitForm}
            disabled={disableButton()}
            className="btn btn-primary btn-large"
          >
            Continuar
          </button>
        </form>
      )}

      {/* LISTA */}
      <div className="block pt-10 lg:pt-8 pb-[128px]">
        <ul className="info-card-download">
          {list.map((item, index) => (
            <li key={index}>
              <div>
                <div className="icon-container">
                  <i className="icon icon-cash text-primary-90 text-[20px]"></i>
                </div>
                <div className="description">
                  <p>Al corte {formatDate(item.fechaCorte, "DD-MM-YYYY")}</p>
                  <h5 className="lead font-semibold">
                    RD$ {convertToMoney(item.monto)}
                  </h5>
                </div>
              </div>
              <button
                onClick={() => download(item.fechaCorte)}
                className="btn btn-secondary btn-medium hidden lg:inline-flex"
              >
                Descargar
              </button>
              <button
                className="block lg:hidden"
                onClick={() => download(item.fechaCorte)}
              >
                <i className="icon icon-download text-gray-50 text-[26px]"></i>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default PublicAccountStatements;
